import React, { useState } from 'react'
import { FaUserMd } from 'react-icons/fa';
import MaintenanceCompaniesScreen from '../MaintainaceCompanies/MaintenanceCompanies';
import SuppliersScreen from '../Suppliers/Suppliers';
import { Card, Tabs } from 'antd';
import { BiBuildings } from 'react-icons/bi';

const ContractsScreen = () => {
    // const { isMobile, isTablet } = useResponsive();
    const [activeTab, setActiveTab] = useState('companies');

    const tabItems = [
        {
            key: 'companies',
            label: (
                <span className="flex items-center gap-2">
                    <BiBuildings />
                    Companies
                </span>
            ),
            children: <MaintenanceCompaniesScreen/>
        },
        {
            key: 'suppliers',
            label: (
                <span className="flex items-center gap-2">
                    <FaUserMd />
                    Suppliers
                </span>
            ),
            children: <SuppliersScreen  />
        }
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
            <style jsx>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 640px) {
                    .ant-card-body {
                        padding: 16px !important;
                    }
                }
            `}</style>

            <div className={`p-2`}>
                

                <Card className="shadow-lg border-0 bg-white/90 backdrop-blur-sm mt-6">
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={tabItems}
                        className="medical-staff-tabs"
                    />
                </Card>
            </div>
        </div>
    );
};
export default ContractsScreen